import { useAppStore } from './stores/app';

/**
 * Build Authorization headers for the current session.
 *
 * This is intentionally the only place that couples the API layer to the Pinia
 * store (demo mode + role live there). The rest of the API client can stay
 * store-agnostic and easier to test.
 */
export function buildAuthHeaders(token: string | null): Record<string, string> {
  const appStore = useAppStore();
  const headers: Record<string, string> = {};

  if (appStore.isDemoMode) {
    if (!appStore.demoRole) {
      // Guard against transient state where demo mode is enabled before role hydration.
      console.warn('[API] Demo mode active without demo role; withholding Authorization header.');
      return headers;
    }
    headers.Authorization = `Demo demo-${appStore.demoRole}-token`;
    return headers;
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
}

